import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { replace } from 'connected-react-router'

export const useRouteAction = (user, actions) => {
  const dispatch = useDispatch()
  const {
    search,
    pathname,
    query: { action },
  } = useSelector(s => s.router.location)

  useEffect(() => {
    if (action && user.loaded) {
      dispatch(replace(search.replace(/[?&]action=\w+/, '') || pathname))
      actions[action]?.(user)
    }
  }, [user])
}
